"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityContextProvider = exports.IdentityContext = exports.withIdentityContext = exports.useIdentityContext = exports.useIdentityProviderProps = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Provider_1 = require("../app/Provider");
const I18n_1 = require("../i18n/I18n");
const UI_1 = require("../ui/UI");
const Auth_1 = require("./Auth");
function useIdentityProviderProps(props) {
    return Object.assign({ user: undefined, login: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error("User does not exist");
        }), logout: () => tslib_1.__awaiter(this, void 0, void 0, function* () { return undefined; }), identityProvider: undefined, AuthComponent: Auth_1.Auth, useFetchUser: () => ({ data: null, loading: false, refetch: () => null }), displayName: (user) => { var _a; return (_a = user["username"]) !== null && _a !== void 0 ? _a : ""; } }, props);
}
exports.useIdentityProviderProps = useIdentityProviderProps;
const { Context: IdentityContext, useContext } = Provider_1.createProvider(Object.assign(Object.assign({}, useIdentityProviderProps()), { displayName: () => "", setUser: () => null }));
exports.IdentityContext = IdentityContext;
function IdentityContextProvider(_a) {
    var { AuthComponent, logout, identityProvider, useFetchUser, displayName, login } = _a, props = tslib_1.__rest(_a, ["AuthComponent", "logout", "identityProvider", "useFetchUser", "displayName", "login"]);
    const [userState, setUserState] = react_1.useState();
    const { useErrorNotification, useErrorAlert, useLoader } = UI_1.useUIContext();
    const { t } = I18n_1.useTranslation("identity");
    const { errorNotification, setErrorNotification } = useErrorNotification({
        title: t("Authentication"),
    });
    const { errorAlert, setErrorAlert } = useErrorAlert();
    const { loader, setLoading } = useLoader();
    const { data: user, loading, error } = useFetchUser();
    const setUser = (newUser) => {
        setUserState((currentUser) => (currentUser === newUser ? currentUser : newUser));
    };
    react_1.useEffect(() => {
        setLoading(loading);
        if (loading) {
            setUser(undefined);
            return;
        }
        if (user && userState) {
            return;
        }
        setUser(user);
    }, [user, loading]);
    react_1.useEffect(() => {
        setErrorAlert(error);
    }, [error]);
    const loginHandler = (values) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const user = yield login(values);
        setUser(user);
        return user;
    });
    const logoutHandler = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            yield logout();
            setUser(null);
        }
        catch (error) {
            setErrorNotification(error);
        }
    });
    const displayNameHandler = () => {
        return userState ? displayName(userState) : null;
    };
    const providerValues = Object.assign(Object.assign({}, props), { displayName: displayNameHandler, useFetchUser, user: userState, login: loginHandler, logout: logoutHandler, identityProvider,
        AuthComponent,
        setUser });
    return (jsx_runtime_1.jsxs(IdentityContext.Provider, Object.assign({ value: providerValues }, { children: [loader, errorNotification, errorAlert, props.children] }), void 0));
}
exports.IdentityContextProvider = IdentityContextProvider;
function useIdentityContext() {
    return useContext();
}
exports.useIdentityContext = useIdentityContext;
function withIdentityContext(Component, identityProviderProps) {
    return (jsx_runtime_1.jsx(IdentityContextProvider, Object.assign({}, useIdentityProviderProps(identityProviderProps), { children: jsx_runtime_1.jsx(Component, {}, void 0) }), void 0));
}
exports.withIdentityContext = withIdentityContext;
//# sourceMappingURL=Identity.js.map